/*
 * @Author: pengyong
 * @Date: 2020-11-30 22:38:26
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-08 20:58:55
 * @Description:
 * @FilePath: /exhibit/src/utils/index.js
 */
import vm from "@/main";
export const APPID = "e66adcae4a69407d95ce9974ffe50320";

window.logout = function() {
    localStorage.removeItem("token_type");
    localStorage.removeItem("access_token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("GUEST_ID")
    vm.$store.commit("setState", {
        userInfo: {}
    });
    // location.reload();
    // if (location.hash !== "#/exhibition") {
    //     window.location.href = "/#/exhibition";
    // }
};



// WEBPACK FOOTER //
// ./src/utils/index.js